import * as React from 'react';
import { Box } from '@apia/theme';

export const ShowResponsive = ({
  show = [true],
  children,
  display = 'block',
}: {
  display?: string;
  show?: boolean[];
  children: React.ReactNode;
}) => {
  return (
    <Box sx={{ display: show.map((def) => (def ? display : 'none')) }}>
      {children}
    </Box>
  );
};
